import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Card,
  CardHeader,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  Casino as CasinoIcon,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";

import { useNavigate } from "react-router-dom";
import GameInfoBtn from "app/Components/Buttons/FilledBtns/GameInfoBtn";
import MsgBtn from "app/Components/Buttons/FilledBtns/MsgBtn";
import DelReqBtn from "app/Components/Buttons/FilledBtns/DelReqBtn";
import { createHash } from "utils/helperFunctions";
import DB from "_DatabaseFunctions/directConnect";

function CurrentGame() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const user = useSelector((state: any) => state.user.user);
  const CurrentGame = useSelector((state: any) => state.games.playerCurrentGame);
  const navigate = useNavigate();

  useEffect(() => {}, [CurrentGame]);

  const games = Object.keys(CurrentGame || {});

  if (games.length === 0) {
    return null;
  }

  const headerCellStyle = {
    fontWeight: 600,
    fontSize: isMobile ? '0.75rem' : '0.875rem',
    color: 'success.contrastText',
    bgcolor: 'success.main',
    py: isMobile ? 1.5 : 2,
    px: isMobile ? 1 : 2,
    borderBottom: 'none',
  };

  return (
    <Card 
      elevation={2}
      sx={{ 
        borderRadius: 2,
        bgcolor: 'background.paper',
        border: `1px solid ${theme.palette.success.light}`,
        overflow: 'hidden'
      }}
    >
      <CardHeader
        title={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CheckCircleIcon color="success" />
            <Typography variant="h6" sx={{ fontWeight: 600, color: 'success.main' }}>
              Currently in Game
            </Typography>
          </Box>
        }
        sx={{
          bgcolor: 'success.light',
          borderBottom: `1px solid ${theme.palette.success.main}`,
          py: 2
        }}
      />
      <CardContent sx={{ p: 0 }}>
        <TableContainer
          sx={{
            '& .MuiTableCell-root': {
              borderBottom: `1px solid ${theme.palette.divider}`,
            }
          }}
        >
          <Table size={isMobile ? 'small' : 'medium'}>
            <TableHead>
              <TableRow>
                <TableCell sx={headerCellStyle}>
                  Game Name
                </TableCell>
                <TableCell sx={headerCellStyle} align="center">
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {games.map((game) => {
                const gameData = CurrentGame[game];
                return (
                  <TableRow 
                    key={gameData.id}
                    hover
                    sx={{
                      '&:hover': {
                        bgcolor: 'action.hover',
                        cursor: 'pointer'
                      },
                      '& .MuiTableCell-root': {
                        py: isMobile ? 1 : 1.5,
                        px: isMobile ? 1 : 2,
                      }
                    }}
                  >
                    <TableCell
                      onClick={() => navigate(`/games/${gameData.id}`)}
                      sx={{ cursor: 'pointer' }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CasinoIcon color="primary" fontSize="small" />
                        <Typography 
                          variant="body2" 
                          sx={{ 
                            fontWeight: 500,
                            color: 'primary.main',
                            '&:hover': { textDecoration: 'underline' }
                          }}
                        >
                          {gameData.gameName}
                        </Typography>
                      </Box>
                    </TableCell>
                    
                    <TableCell align="center">
                      <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
                        <MsgBtn userId={gameData.hostId} tip="Message Host" />
                        <DelReqBtn
                          action={() => {
                            const reqId = createHash(user.uid + gameData.id);
                            DB.deleteRequest(reqId);
                            DB.removePlayerFromGame(gameData.id, user.uid);
                            DB.endPlayerSession({
                              gameId: gameData.id,
                              playerId: user.uid,
                            });
                          }}
                          tip="Leave Game"
                        />
                        <GameInfoBtn gameId={gameData.id} />
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}

export default CurrentGame;
